import { Factory } from '../interface/factory'
import {
  applyEntitySchema,
  objectSchema,
  openUnion,
  parseEntity,
  sourceJson,
} from '../../_utils/fcdc-v2'
import * as z from 'zod'

export enum SessionPriceAlgorithmType {
  Rates = 'Rates',
  Slots = 'Slots',
}

const SessionPriceAlgorithmSchema = openUnion('type', {
  [SessionPriceAlgorithmType.Rates]: objectSchema({
    type: z.literal(SessionPriceAlgorithmType.Rates),
  }),
  [SessionPriceAlgorithmType.Slots]: objectSchema({
    type: z.literal(SessionPriceAlgorithmType.Slots),
  }),
})

export class SessionPriceAlgorithm {
  type: SessionPriceAlgorithmType

  constructor(json: any) {
    const source = sourceJson(json) as Record<string, unknown>
    this.type = source['type'] as SessionPriceAlgorithmType
    applyEntitySchema(this, SessionPriceAlgorithmSchema, source, {})
  }

  static getFactory(): Factory<SessionPriceAlgorithm> {
    return new (class implements Factory<SessionPriceAlgorithm> {
      make(json: any): SessionPriceAlgorithm {
        if (json?.type === SessionPriceAlgorithmType.Rates) {
          return new RatesSessionPriceAlgorithm(json)
        }
        if (json?.type === SessionPriceAlgorithmType.Slots) {
          return new SlotsSessionPriceAlgorithm(json)
        }
        return parseEntity(SessionPriceAlgorithmSchema, json ?? {}) as SessionPriceAlgorithm
      }

      getTableName(): string {
        throw new Error(
          'getTableName() should never be called on a SessionPriceAlgorithm. SessionPriceAlgorithms are not stored in IndexDB.'
        )
      }
    })()
  }
}

export class RatesSessionPriceAlgorithm extends SessionPriceAlgorithm {
  constructor(json: any) {
    super(json)
  }
}

export class SlotsSessionPriceAlgorithm extends SessionPriceAlgorithm {
  constructor(json: any) {
    super(json)
  }
}
